import { jwtDecode } from 'jwt-decode';

export function jwtExpiresAt(token: string, parseFromStart: boolean): number {
  try {
    const { exp } = jwtDecode(token, { header: !parseFromStart });
    return (exp || 0) * 1000;
  } catch (error) {
    return 0;
  }
}
